import axiosInstance from "../utils/axios/axiosInstance";

// Update Admin Password API
export const updateAdminPassword = async ({ oldPassword, newPassword }) => {
  try {
    const response = await axiosInstance.post('auth/changePassword', { oldPassword, newPassword });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to update password');
  }
};
// Update Profile API
export const updateProfile = async (payload) => {
  try {
    const response = await axiosInstance.patch('admin/profile', payload);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to update profile');
  }
};

export const signin = async (data) => {
  try {
    const response = await axiosInstance.post('auth/admin/login', data);
    localStorage.setItem('admin_accesstoken', JSON.stringify(response?.data?.data?.access));
    localStorage.setItem('admin_refreshtoken', JSON.stringify(response?.data?.data?.refresh));
    // localStorage.setItem('accesstoken', response?.data?.data?.acess);
    // localStorage.setItem('refreshtoken', response?.data?.data?.refresh);
    // localStorage.setItem('role', response?.data?.data?.user?.role);
    return response.data; 
  } catch (error) {
   console.log(error)
    throw new Error(error.response?.data?.message || 'An error occurred during signin');
  }
};

export const logoutAdmin = async () => {
  try {
    const response = await axiosInstance.post('admin/logout');
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Logout failed');
  }
};

// Forgot Password API
export const forgotPassword = async ({ email }) => {
  try {
    const response = await axiosInstance.post('auth/forgetPassword', { email });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to send reset link');
  }
};

// Reset Password API
export const resetPassword = async ({ token, newPassword }) => {
  try {
    const response = await axiosInstance.post('auth/resetPassword', { token, newPassword });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to reset password');
  }
};
